module.exports = __webpack_public_path__ + "static/media/space_color.d24f9d92.jpg";